import { REHYDRATE } from "redux-persist";
import * as actionTypes from "./cartActionTypes";

const initialState = {
  savedCategories: {},
  lastUpdated: null,
  cart_expiration_minutes: 10,
};

function reducer(state = initialState, action: any) {
  switch (action.type) {
    case actionTypes.UPDATE_CART:
      // console.log("Updating cart with payload:", action);
      return {
        ...state,
        savedCategories: { ...action.obj },
        lastUpdated: Date.now(),
      };

    case actionTypes.CLEAR_CART:
      return {
        ...state,
        savedCategories: {},
        lastUpdated: null,
      };

    case actionTypes.SET_CART_EXPIRATION:
      return {
        ...state,
        cart_expiration_minutes: action.cartExpMinutes,
      };

    case actionTypes.CLEAR_STORE_ITEM: {
      var key = action?.item;
      var obj: any = {};
      obj[key] = {};

      return {
        ...state,
        ...obj,
      };
    }

    case REHYDRATE:
      // console.log('Rehydrated state:', action.payload);
      return {
        ...state,
        ...action.payload?.cart,
      };
    default:
      return state;
  }
}

export default reducer;
